// extracted by mini-css-extract-plugin
export default {"wrapper":"EditOptionsModal_wrapper__LbFwb","icon":"EditOptionsModal_icon__3FyIR","option":"EditOptionsModal_option__vTd1z","content":"EditOptionsModal_content__9wR-M"};